<template>
    <div class="page">
        <div class="el-flex">
            <div class="title">售后服务</div>
            <div class="icon-flex">
                 <div class="icon-flex-item" @click="cjwt">
                    <div class="item-img"><img src="@/assets/userNew/29.png" alt=""></div>
                    <div class="item-name">意见征集</div>
                </div>

                <div class="icon-flex-item" @click="tuTouSu">
                    <div class="item-img"><img src="@/assets/userNew/icon39.png" alt=""></div>
                    <div class="item-name">投诉商家</div>
                </div>

                <div class="icon-flex-item" @click="goChangeCard" v-if="isTochangeCard==1">
                    <div class="item-img"><img src="@/assets/userNew/icon41.png" alt=""></div>
                    <div class="item-name">换卡申请</div>
                </div>
                <div class="icon-flex-item" @click="updatePwd">
                    <div class="item-img"><img src="@/assets/userNew/icon43.png" alt=""></div>
                    <div class="item-name">修改余额密码</div>
                </div>
            </div>
        </div>
        <div class="el-flex">
            <div class="title">查询办理</div>
            <div class="icon-flex">
              <!-- <div class="icon-flex-item" @click="device" v-if="isPower==1">
                    <div class="item-img"><img src="@/assets/home/shebei.jpg"  alt=""></div>
                    <div class="item-name">设备管理</div>
                </div>

                <div class="icon-flex-item" @click="checkoutNet" >
                    <div class="item-img"><img src="@/assets/home/shebei.jpg"  alt=""></div>
                    <div class="item-name">网络切换</div>
                </div> -->


               <!-- <div class="icon-flex-item" @click="toApplyShop" v-if="yucun == 3 || yucun == 8888">
                    <div class="item-img"><img src="@/assets/userNew/icon43.png" alt=""></div>
                    <div class="item-name">充值活动余额</div>
                </div> -->
               

                <div class="icon-flex-item" @click="nowPkg">
                    <div class="item-img"><img src="@/assets/userNew/icon47.png" alt=""></div>
                    <div class="item-name">本月套餐</div>
                </div>
                <div class="icon-flex-item" @click="nextPkg">
                    <div class="item-img"><img src="@/assets/userNew/icon40.png" alt=""></div>
                    <div class="item-name">次月套餐</div>
                </div>
                <div class="icon-flex-item" @click="toBalanceRecharge">
                    <div class="item-img"><img src="@/assets/userNew/icon42.png" alt=""></div>
                    <div class="item-name">充值记录</div>
                </div>
                
                <div class="icon-flex-item" @click="toPriceOrder">
                    <div class="item-img"><img src="@/assets/userNew/icon45.png" alt=""></div>
                    <div class="item-name">会员积分</div>
                </div>
                
                <div class="icon-flex-item" @click="toOutLogin">
                    <div class="item-img"><img src="@/assets/userNew/icon48.png" alt=""></div>
                    <div class="item-name">退出登录</div>
                </div>
                <!-- <div class="icon-flex-item" @click="toApplyShop">
                    <div class="item-img"><img src="@/assets/userNew/30.png" alt=""></div>
                    <div class="item-name">流量兑换券</div>
                </div>
                <div class="icon-flex-item" @click="toApplyTui">
                    <div class="item-img"><img src="@/assets/userNew/36.png" alt=""></div>
                    <div class="item-name">领取余额</div>
                </div> -->
            </div>
        </div>


         <!-- 修改密码框   -->
    <div
      class="van-overlay"
      style="z-index: 1999"
      v-show="showPasswordPanel"
    ></div>
    <div
      class="van-popup van-popup--round van-popup--center changePasswordPanel"
      style="z-index: 2000; min-height: 55%; min-width: 80%"
      v-show="showPasswordPanel"
      :style="{ top: passwordPanelTop + '%' }"
    >
      <van-icon
        name="cross"
        class="icon-cross"
        @click="cancelChangePassword()"
      />

      <!-- 原密码输入框 -->
      <p>原密码：</p>
      <van-password-input
        :value="oldPassword"
        :focused="oldPasswordKeyboard"
        @focus="oldPasswordOnfocus()"
      />
      <!-- 新密码输入框 -->
      <p>新密码：</p>
      <van-password-input
        :value="newPassword"
        :focused="newPasswordKeyboard"
        @focus="newPasswordOnfocus()"
      />
      <!-- 原密码输入框 -->
      <p>再次确认：</p>
      <van-password-input
        :value="confirmPassword"
        :focused="confirmPasswordKeyboard"
        @focus="confirmPasswordOnfocus()"
      />
      <div class="confirmChangePassword">
        <van-button
          class="confirmChangePasswordBtn"
          plain
          hairline
          type="info"
          @click="sureToChangePassword()"
          >确 定</van-button
        >
      </div>

       <!-- 数字键盘 -->
    <van-number-keyboard
      :z-index="2015"
      :show="oldPasswordKeyboard"
      @input="oldPasswordOnInput"
      @delete="oldPasswordOnDelete"
      @blur="oldPasswordKeyboard = false"
    />

    <van-number-keyboard
      :z-index="2015"
      :show="newPasswordKeyboard"
      @input="newPasswordOnInput"
      @delete="newPasswordOnDelete"
      @blur="newPasswordKeyboard = false"
    />

    <van-number-keyboard
      :z-index="2015"
      :show="confirmPasswordKeyboard"
      @input="confirmPasswordOnInput"
      @delete="confirmPasswordOnDelete"
      @blur="confirmPasswordKeyboard = false"
    />
    <!-- 数字键盘 end -->


    </div>

     <!--  更多套餐信息  -->
    <van-popup
      v-model="pkgListVisible"
      closeable
      position="bottom"
      style="min-height: 35%; max-height: 75%"
    >
      <div class="pkgList">
        <h3 v-show="simInfo.simPackageList[0]">当前套餐:</h3>
        <h3 v-show="!simInfo.simPackageList[0]" style="color: red">
          未订购可用套餐
        </h3>
        <ul>
          <li v-for="item in simInfo.simPackageList" :key="item.id">
            <p>{{ item.packageName }}</p>
            <p v-if="item.stateName == '已充值'" style="color: #32c5e9">
              已充值
            </p>
            <p v-else style="color: red">充值中</p>
            <div>
              <p>生效时间： {{ item.startTime }}</p>
              <p
                v-if="
                  new Date(
                    getDateByTimeStr(item.endTime)[0],
                    getDateByTimeStr(item.endTime)[1],
                    getDateByTimeStr(item.endTime)[2],
                    getDateByTimeStr(item.endTime)[3],
                    getDateByTimeStr(item.endTime)[4],
                    getDateByTimeStr(item.endTime)[5]
                  ) < new Date()
                "
                style="color: red"
              >
                过期时间： {{ item.endTime }}
              </p>
              <p v-else>过期时间： {{ item.endTime }}</p>
            </div>
          </li>
        </ul>
      </div>
    </van-popup>
    <van-popup
      v-model="pkgListVisible1"
      closeable
      position="bottom"
      style="min-height: 35%; max-height: 75%"
    >
      <div class="pkgList">
        <h3 v-show="simInfo.simNextPackageList[0]">次月套餐:</h3>
        <h3 v-show="!simInfo.simNextPackageList[0]" style="color: red">
          未订购次月套餐
        </h3>
        <ul>
          <li v-for="item in simInfo.simNextPackageList" :key="item.id">
            <p>{{ item.packageName }}</p>
            <p v-if="item.stateName == '已充值'" style="color: #32c5e9">
              已充值
            </p>
            <p v-else style="color: red">充值中</p>
            <div>
              <p>生效时间： {{ item.startTime }}</p>
              <p
                v-if="
                  new Date(
                    getDateByTimeStr(item.endTime)[0],
                    getDateByTimeStr(item.endTime)[1],
                    getDateByTimeStr(item.endTime)[2],
                    getDateByTimeStr(item.endTime)[3],
                    getDateByTimeStr(item.endTime)[4],
                    getDateByTimeStr(item.endTime)[5]
                  ) < new Date()
                "
                style="color: red"
              >
                过期时间： {{ item.endTime }}
              </p>
              <p v-else>过期时间： {{ item.endTime }}</p>
            </div>
          </li>
        </ul>
      </div>
    </van-popup>
    <!--  更多套餐信息  end -->



        
    </div>
</template>
<script>
import { wxRequest } from '@/api/user'
import { Toast,Dialog } from 'vant';
export default{
  data(){
    return{
      isPower: localStorage.getItem("isShowShebei"),
      yucun: localStorage.getItem("yucun"),
      pkgListVisible:false,
      pkgListVisible1:false,
        //修改密码
      showPasswordPanel: false,

      oldPasswordKeyboard: false,
      newPasswordKeyboard: false,
      confirmPasswordKeyboard: false,

      oldPassword: "",
      newPassword: "",
      confirmPassword: "",
      passwordPanelTop: 50, 
      //修改密码 end
      alreadyHasAccount:localStorage.getItem('alreadyHasAccount'),
      isTochangeCard:localStorage.getItem('isTochangeCard'),
      iccid: localStorage.getItem("iccid"),
      simInfo:{},
    }
  },
  created(){
    this.getUserSimInfo();
  },
  methods:{
    checkoutNet(){
      this.$router.push({
            path: "/user/checkoutNet"
          });
    },
    
    device() {
      this.$router.push({
        path: "/user/device"
      });
    },

      toOutLogin(){
          window.location.href='http://vx.iot688.cn/#/userNew/login'
      },
      toPriceOrder(){
        this.$router.push({
          name: "applySalePkg",
          query: { iccid: this.simInfo.iccid },
        });
      },
      nextPkg(){
          this.pkgListVisible1=true;
      },
      nowPkg(){
        this.pkgListVisible=true;
      },
      getUserSimInfo() {
        wxRequest("sim/detail", { iccid: this.$store.state.iccid }, "post").then((res) => {
          if (res.data.code == 200) {
            let result = res.data.data;
            if (result.flowRatePool == "电信") {
              this.ctccAuthShow = true;
            } else if (result.flowRatePool == "联通") {
              this.cuccAuthShow = true;
            } else if (result.flowRatePool == "前海") {
              this.qianhaiSHow = true;
            } else if (result.flowRatePool == "移动") {
              this.cmccAuthShow = true;
            } else if (result.flowRatePool == "乐语") {
              this.leyuAuthShow = true;
            } else if (result.flowRatePool == "移动接口") {
              this.cmccXxtx = true;
            } else {
              this.otherUrl = result.flowRatePool;
              this.otherAuth = true;
            }
            localStorage.setItem('simInfoMap',result);
            sessionStorage.setItem("supplierCode", result.supplierCode);

            this.simInfo = result;

            if (result.simPackageList.length > 1) {
              for (let i = 0; i < result.simPackageList.length; i++) {
                if (
                  result.simPackageList[i].flowRatePercent &&
                  (result.simPackageList[i].flowRatePercent / 100) *
                    result.simPackageList[i].flowRate >
                    result.simPackageList[i].usedFlowRate
                ) {
                  this.simInfo.packageName =
                    result.simPackageList[i].packageName;
                  this.simInfo.endTime = result.simPackageList[i].endTime;
                  break;
                }
              }
            } else if (result.simPackageList.length == 1) {
              this.simInfo.packageName = result.simPackageList[0].packageName;
              this.simInfo.endTime = result.simPackageList[0].endTime;
            }
            this.simInfo.simId = this.simInfo.simPackageList[0]
              ? this.simInfo.simPackageList[0].simId
              : "";
          }
        }
      );
    },
    getDateByTimeStr(timeStr) {
      if (timeStr && typeof timeStr === "string") {
        let dayStr = timeStr.split(" ")[0].split("-");
        let hourStr = timeStr.split(" ")[1].split(":");
        return dayStr.concat(hourStr);
      }
      return timeStr;
    },
    tuTouSu(){
        this.$router.push({
            path: "/user/entrance",
        });
    },
    cjwt(){
        // this.$router.push({
        //     path: "/userNew/problem",
        // });

        this.$router.push({
            path: "/user/subColloct",
        });
    },
    goChangeCard(){
      this.$router.push({
        name: "userChgCard",
        query: {
          oldIccid: localStorage.getItem("iccid"),
          changeCmccSim: cardType,
        },
      });
    },
    updatePwd(){
      if(this.alreadyHasAccount==1){
          this.showPasswordPanel=true;
      }else{
           Dialog.confirm({
                      title: "购买余额提醒",
                      message:  "当前卡尚未购买余额，请购买余额后再来重置密码！",
                  }).then((action) => {
                      if (action == "confirm") {
                           this.$router.replace("/user/balanceRecharge");
                      }
                  }).catch(() => {});
      }
    },
    detailsTo(){
      this.$router.push({
        path: "/userNew/coupon",
        query: {
            iccid: this.iccid,
        },
      });
    },
    toApplyShop() {
      this.$router.push({
        path: "/user/huodong2",
        query: {
            iccid: this.iccid,
        },
      });
    },
    toApplyTui(){
      this.$router.push({
        name: "applyTui",
        query: { iccid: this.iccid },
      });
    },
             /***   修改密码     ***/
    oldPasswordOnfocus() {
      this.oldPasswordKeyboard = true;
      this.newPasswordKeyboard = false;
      this.confirmPasswordKeyboard = false;
      this.passwordPanelTop = 30;
    },
    oldPasswordOnDelete() {
      this.oldPassword = this.oldPassword.slice(0, this.oldPassword.length - 1);
    },

    oldPasswordOnInput(key) {
      this.oldPassword = (this.oldPassword + key).slice(0, 6);
    },

    newPasswordOnfocus() {
      this.oldPasswordKeyboard = false;
      this.newPasswordKeyboard = true;
      this.confirmPasswordKeyboard = false;
      this.passwordPanelTop = 30;
    },
    newPasswordOnDelete() {
      this.newPassword = this.newPassword.slice(0, this.newPassword.length - 1);
    },

    newPasswordOnInput(key) {
      this.newPassword = (this.newPassword + key).slice(0, 6);
    },

    confirmPasswordOnfocus() {
      this.oldPasswordKeyboard = false;
      this.newPasswordKeyboard = false;
      this.confirmPasswordKeyboard = true;
      this.passwordPanelTop = 30;
    },
    confirmPasswordOnDelete() {
      this.confirmPassword = this.confirmPassword.slice( 0, this.confirmPassword.length - 1);
    },

    confirmPasswordOnInput(key) {
      this.confirmPassword = (this.confirmPassword + key).slice(0, 6);
    },

    cancelChangePassword() {
      this.oldPassword = "";
      this.newPassword = "";
      this.confirmPassword = "";
      this.passwordPanelTop = 50;
      this.showPasswordPanel = false;
    },

    sureToChangePassword() {
      if (
        this.oldPassword.length < 6 ||
        this.newPassword.length < 6 ||
        this.confirmPassword.length < 6
      ) {
        Dialog.alert({
          message: "请输入六位密码",
        });
        return;
      }

      if (this.newPassword != this.confirmPassword) {
        Dialog.alert({
          message: "两次输入的新密码不一致",
        });
        return;
      }

      let data = {
        iccid: this.$store.state.iccid,
        paypassOld: this.oldPassword,
        paypass: this.confirmPassword,
      };
      wxRequest("sysUser/account/user/resetPaypass", data, "post").then(
        (res) => {
          if (res.data.code == 200) {
            Toast.success(res.data.message);
            this.cancelChangePassword();
          } else {
            Dialog.alert({
              message: res.data.message,
            });
          }
        }
      );
    },
    /***   修改密码  end   ***/
    toBalanceRecharge() {
      this.$router.push({
        path: "/user/balanceRechargeRecord",
        query: {
          iccid: this.$store.state.iccid,
        },
      });
    }
  }
}
</script>
<style lang="less" scoped>
div{
    display: flex;
    flex-grow: 0;
    flex-basis: auto;
    align-items: stretch;
    flex-direction: column;
}
.page{
	height:100%;
	background: #f7f8fa;
    .el-flex{
        background-color: #fff;
        align-self: center;
        margin-top: 20px;
        border-radius: 20px;
        padding: 12px 0;
        width:90%;
        .title{
            font-size: 15px;
            font-weight: 700;
            color: #06121e;
            margin-left: 15px;
            margin-bottom: 7px;
        }
        .icon-flex{
            flex-wrap: wrap;
            flex-direction: row;
            .icon-flex-item{
                min-width: 83px;
                margin: 10px 0px 10px;
                align-items: center;
                flex-direction: column;
                .item-img{
                    width: 48px;
                    height: 48px;
                }
                .item-name{
                    font-size: 12px;
                    font-weight: 700;
                    color: #3d444d;
                    margin-top: 5px;
                }
            }
        }
    }
}
</style>

<style lang="less">
#balanceRecharge .checkstand-defined-popup .van-field__control{
    font-size: 24px;
}

#balanceRecharge .checkstand-defined-popup input::-webkit-input-placeholder { 
    /* Chrome/Opera/Safari */ 
    font-size: 14px;
}
#balanceRecharge .checkstand-defined-popup input::-moz-placeholder { 
    /* Firefox 19+ */  
    font-size: 14px;
}
#balanceRecharge .checkstand-defined-popup input::-ms-input-placeholder { /* IE 10+ */ 
    font-size: 14px;
}
#balanceRecharge .checkstand-defined-popup input::-moz-placeholder { 
    /* Firefox 18- */ 
    font-size: 14px;
}

#balanceRecharge .passwordInput .van-field__control{
    height: 24px;
}

.changePasswordPanel [class*=van-hairline]::after{
    border-color: #c4cedc;
}

.changePasswordPanel{
	  padding: 10px;

    .icon-cross{
        position: absolute; 
        right: 10px;
        font-size: 16px;
    }

    p{
        margin: 10px 16px 0 16px;
        line-height: 30px;
    }

    .confirmChangePassword{
        display:flex;
        justify-content: flex-end;
        margin-top: 20px;
        flex-direction: row;
        .confirmChangePasswordBtn{
            width: 80px;
            margin: 0 15px;
        }
    }
}
.pkgList {
    padding: 10px 20px;

    h3 {
      margin-top: 20px;
      font-size: 14px;
      line-height: 28px;
      font-weight: bold;
    }

    ul {
      line-height: 38px;

      li {
        display: flex;
        justify-content: space-between;
        margin-bottom: 15px;

        > p {
          display: flex;
          align-items: center;
        }

        > div {
          p {
            line-height: 18px;
            font-size: 12px;
          }
        }
      }
    }
  }
</style>